import { keyBy } from 'lodash';
import sdk from '../../qoc-sdk';

export const types = {
  ON_FETCH_PROFILES_FULFILLED: 'ON_FETCH_PROFILES_FULFILLED',
  ON_FETCH_PROFILES_PENDING: 'ON_FETCH_PROFILES_PENDING',
  ON_FETCH_PROFILES_REJECTED: 'ON_FETCH_PROFILES_REJECTED',

  ON_FETCH_PROFILE_VO_FULFILLED: 'ON_FETCH_PROFILE_VO_FULFILLED',
  ON_FETCH_PROFILE_VO_PENDING: 'ON_FETCH_PROFILE_VO_PENDING',
  ON_FETCH_PROFILE_VO_REJECTED: 'ON_FETCH_PROFILE_VO_REJECTED',

  ON_REQUEST_RESET_PASSWORD_FULFILLED: 'ON_REQUEST_RESET_PASSWORD_FULFILLED',
  ON_REQUEST_RESET_PASSWORD_PENDING: 'ON_REQUEST_RESET_PASSWORD_PENDING',
  ON_REQUEST_RESET_PASSWORD_REJECTED: 'ON_REQUEST_RESET_PASSWORD_REJECTED',

  ON_UPDATE_PROFILE_FULFILLED: 'ON_UPDATE_PROFILE_FULFILLED',
  ON_UPDATE_PROFILE_PENDING: 'ON_UPDATE_PROFILE_PENDING',
  ON_UPDATE_PROFILE_REJECTED: 'ON_UPDATE_PROFILE_REJECTED',

  ON_UPDATE_USER_PASSWORD_FULFILLED: 'ON_UPDATE_USER_PASSWORD_FULFILLED',
  ON_UPDATE_USER_PASSWORD_PENDING: 'ON_UPDATE_USER_PASSWORD_PENDING',
  ON_UPDATE_USER_PASSWORD_REJECTED: 'ON_UPDATE_USER_PASSWORD_REJECTED'
};

const onFetchProfilesFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_PROFILES_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchProfilesRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_PROFILES_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchProfiles = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_PROFILES_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getProfiles(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onFetchProfilesFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            profiles: keyBy(data.responseEntity, 'profileUUID'),
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchProfilesRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onFetchProfileVOFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback, profileVO } = props;

  window.profileUser = profileVO;

  dispatch({
    data: props,
    type: types.ON_FETCH_PROFILE_VO_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchProfileVORejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_PROFILE_VO_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchProfileVO = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_PROFILE_VO_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getProfileVO({
      useCache: false,
      ...requestProps
    })
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onFetchProfileVOFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            profileVO: data,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchProfileVORejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onRequestResetPasswordFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_REQUEST_RESET_PASSWORD_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onRequestResetPasswordRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_REQUEST_RESET_PASSWORD_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onRequestResetPassword = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_REQUEST_RESET_PASSWORD_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .postPasswordReset(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 201) {
        return dispatch(
          onRequestResetPasswordFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 201'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onRequestResetPasswordRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onUpdateProfileFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_UPDATE_PROFILE_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onUpdateProfileRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_UPDATE_PROFILE_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onUpdateProfile = (props = {}) => (dispatch, getState) => {
  dispatch({
    type: types.ON_UPDATE_PROFILE_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  const { profileUUID, ...otherRequestProps } = requestProps;
  const currentProfile = getState().profile.profileVO.profile;
  const isTargetCurrentProfile = profileUUID === currentProfile.profileUUID;
  const targetProfile = isTargetCurrentProfile
    ? Object.assign({}, currentProfile, otherRequestProps)
    : Object.assign(
        {},
        {
          profileUUID,
          ...otherRequestProps
        }
      );

  return sdk
    .putProfile({
      profile: targetProfile
    })
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onUpdateProfileFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status,
            targetProfile
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onUpdateProfileRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onUpdateUserPasswordFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_UPDATE_USER_PASSWORD_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onUpdateUserPasswordRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_UPDATE_USER_PASSWORD_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onUpdateUserPassword = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_UPDATE_USER_PASSWORD_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .putUserPassword(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onUpdateUserPasswordFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onUpdateUserPasswordRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Profile/actions.js